module.exports = __webpack_public_path__ + "assets/images/project/head/Kimmese.jpg?v=a3d2c697";